import { get } from 'lodash'

const hasPermission = (token) => {

  const tokens = get(window, 'state.user.permission_tokens', [])

  return Array.isArray(tokens) && tokens.indexOf(token) !== -1

}

export default hasPermission
